import React from 'react';

/**
 * Etichetta compatta a pillola.
 *
 * Racchiude la forma condivisa da 21 punti del codice, che differiscono fra
 * loro esclusivamente per la coppia di colori (11 combinazioni distinte:
 * slate, emerald, orange, sky, amber, gray, cyan, indigo, red...).
 *
 * I colori NON sono inclusi: vanno passati dal chiamante tramite className
 * (es. <Badge className="bg-emerald-100 text-emerald-700">). Cosi il
 * componente non impone una semantica di colore e non esiste alcuna classe
 * da sovrascrivere.
 *
 * className non deve ridefinire padding, dimensione o peso del testo: le
 * pillole con geometria diversa (px-2 py-0.5 text-[10px]) restano markup
 * nativo.
 */
export default function Badge({ className = '', ...props }) {
  return (
    <span
      {...props}
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-semibold ${className}`.trim()}
    />
  );
}
